import { SharedModule } from '$shared/shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MainTabsComponent } from './components/main-tabs/main-tabs.component';
import { BatchItemComponent } from '../features/batches/components/batch-item/batch-item.component';

@NgModule({
  declarations: [MainTabsComponent, BatchItemComponent],
  imports: [CommonModule, SharedModule],
  exports: [MainTabsComponent, BatchItemComponent],
})
export class SharedBatchModule {}
